module.exports = __webpack_public_path__ + "static/img/078_TO8_1718.5c5026c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/078_TO8_1718.jpg
// module id = W/mp
// module chunks = 0